module.exports = __webpack_public_path__ + "files/7227dee6ef9204d2970865f5ec02b1f6.png";